import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Maintenance from '../../../functions/logic/Maintenance'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import FormModal from '../../../components/General/FormModal'
import ConfirmModal from '../../../components/ConfirmModal'
import { useSnackbar } from 'notistack'

export default function Bodegas() {
    const [spiner, setSpiner] = useState(false)
    const [isOpenModalform, setIsOpenModalForm] = useState(false)
    const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false)
    const [dataServiceForm, setDataServiceForm] = useState([])
    const [bodegaId, setBodegaId] = useState(0)
    const [saveType, setSaveType] = useState('I')
    const [headerModal, setheaderModal] = useState('I')
    const param = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)

    const columns = ['Nombre', 'Ubicacion', 'Tipo', 'Codigo', 'Estado']

    const getBodegas = useCallback(async (page, perPage, param) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'mantenimiento'
        const response = await Maintenance.bodegasLogic(page, perPage, userToken, param.moduleId)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        if (!response.error) {
            setdata(response["responseTableMapper"])
            setTotalRows(response.total_records)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false)
    }, [enqueueSnackbar, userToken]) 

    useEffect(() => {
        getBodegas(1, 5, param)
    }, [param, getBodegas])

    const handledNew = async () => {
        setheaderModal("Ingresar Nueva Bodega")
        cleanStorage()
        setSaveType("I")
        setBodegaId(0)
        setSpiner(true)
        setDataServiceForm([])
        setIsOpenModalForm(true)
        setSpiner(false)
    }

    const handleEdit = (bodega) => {
        setheaderModal("Editar Bodega");
        setSaveType("E");
        setBodegaId(bodega.id)

        const selectedBodega = data.find(item => item.id === bodega.id);
    
        if (selectedBodega) {
            setDataServiceForm(selectedBodega)
        }
    
        setIsOpenModalForm(true)
    };
    

    const handledSave = async (event) => {
        setSpiner(true)
        event.preventDefault()
        const response = await Maintenance.saveBodegaLogic(userToken, param.moduleId, event.target, bodegaId, saveType)

        if (!response.error) {
            setSpiner(false)
            setIsOpenModalForm(false)
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            setTimeout(function () {
                getBodegas(1, 5, param)
            }, global.DELAY)
        } else {
            setSpiner(false)
            enqueueSnackbar(response.message, {
                variant: "error",
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
    }

    const handleDelete = async (e) => {
        setSpiner(true)
        setBodegaId(e.id)
        setIsOpenModalConfirm(true)
        setSpiner(false)
    }

    const handledConfirmDelete = async (e) => {
        setSpiner(true)
        const response = await Maintenance.deleteProductLogic(userToken, param.moduleId, bodegaId)
        setSpiner(false)
        setIsOpenModalConfirm(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setTimeout(function () {
            getBodegas(1, 5, param)
        }, global.DELAY)
    }

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
        setIsOpenModalConfirm(false)
        cleanStorage()
    }

    const cleanStorage = () => {
        localStorage.removeItem('nombre')
        localStorage.removeItem('ubicacion')
        localStorage.removeItem('tipo')
        localStorage.removeItem('estado')
        localStorage.removeItem('codigo')
    }

    const handlePageChange = (page, perPage) => {
        setSpiner(true)
        getBodegas(page, perPage, param)
        setSpiner(false)
    }

    const handleSearch = (item) => {
        alert(item)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={headerModal}
                button={'Guardar'}
                formData={dataServiceForm}
                handledSave={handledSave}
                opt={'bodegaForm'}
                modalWith={'sm'}
            />
            <ConfirmModal
                isOpen={isOpenModalConfirm}
                handleCloseModal={handleCloseModal}
                header={'Desactivar producto su producto no será visible'}
                body={'Estás seguro de desactivar el producto'}
                button={'Desactivar'}
                formData={dataServiceForm}
                handledConfirmDelete={handledConfirmDelete}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="project-actions text-right">
                                            <button className="btn btn-primary btn-sm" onClick={handledNew}>
                                                <i className="fas fa-folder"></i> Nuevo Producto
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onEdit={handleEdit}
                                                onDelete={handleDelete}
                                                onSearch={handleSearch}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}




